<template>
  <slot name="trigger" :open="() => showModal = true" />

  <Dialog :open="showModal" @update:open="onDialogUpdate">
    <DialogScrollContent>
      <form :action="resendUrl" method="post">
        <input type="hidden" name="_token" :value="csrfToken">
        <DialogHeader>
          <DialogTitle>
            {{ $t('Resend invitation') }}
          </DialogTitle>
        </DialogHeader>

        <input v-for="userId in selectedUserIds" type="hidden" name="user_ids[]" :value="userId" :key="userId">

        <p class="tw:text-md tw:leading-none tw:font-semibold tw:mt-4 tw:mb-2">
          {{ $t("Associated members to notify") }}
        </p>

        <MemberNotificationList
          :permissions="permissions"
          @update:selected-ids="selectedUserIds = $event"
        />

        <DialogFooter class="mt-3">
          <Button variant="secondary" @click="discardModal">
            {{ $t('Cancel') }}
          </Button>
          <Button variant="default" :disabled="selectedUserIds.length === 0">
            {{ $t('Send invitation') }}
          </Button>
        </DialogFooter>
      </form>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import { ref } from 'vue';
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/shadcn/components/ui/button/index.js";
import MemberNotificationList from "@/components/Tour/MemberNotificationList.vue";

defineProps({
  resendUrl: {
    type: String,
    required: true,
  },
  permissions: {
    type: Array,
    required: true,
  },
});

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
const showModal = ref(false);
const selectedUserIds = ref([]);

const discardModal = () => {
  showModal.value = false;
  selectedUserIds.value = [];
};

const onDialogUpdate = (isOpen) => {
  if (isOpen) {
    showModal.value = true;
  } else {
    discardModal();
  }
};
</script>
